import {
  Button,
  Modal,
  useTheme,
  Card,
  Box,
  Typography,
  IconButton,
} from "@mui/material";
import { ReactNode, useMemo, useState } from "react";
import __ from "src/utils/Translations";
import CloseIcon from "@mui/icons-material/Close";
import { useCompanyId } from "src/Pages/Company/CompanyContext";
import { useStructureStore } from "src/Pages/Company/OrganizationStructure/context/useStructureStore";
import { usePermission } from "src/utils/hooks/permissions/usePermissions";
import {
  organizationStructureAreaExport,
  organizationStructureAreaImport,
} from "src/utils/RoleBasedSecurity/permissions";
import Export from "./Buttons/Export";
import DataCard from "./DataCard";

export interface IDataCards {
  mainText: string;
  secondaryText: string;
  type: "download" | "upload";
  actionButtons: ReactNode;
}

const Area = () => {
  const companyId = useCompanyId();
  const structureId = useStructureStore((state) => state.structureId);
  const theme = useTheme();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const hasPermissionsStructureAreaImport = usePermission(
    organizationStructureAreaImport
  );

  const hasPermissionsStructureAreaExport = usePermission(
    organizationStructureAreaExport
  );

  const handleOpen = () => {
    setIsModalOpen(true);
  };

  const handleClose = () => {
    setIsModalOpen(false);
  };

  const dataCards: IDataCards[] = useMemo(() => {
    const cards: IDataCards[] = [];

    if (hasPermissionsStructureAreaImport) {
      cards.push(
        {
          mainText: "Pobierz szablon do importu",
          secondaryText:
            "Pobierz szablon, który można uzupełnić nowymi obszarami lub zaktualizować już utworzone.",
          type: "download",
          actionButtons: (
            <Button
              variant="contained"
              sx={{
                width: "100%",
                fontSize: "13px",
                fontWeight: "700",
                margin: "auto 0 0 0",
                padding: "16px 12px",
              }}
            >
              {__("Pobierz")}
            </Button>
          ),
        },
        // {
        //   mainText: "Importuj przygotowany plik",
        //   secondaryText: "Dodaj nowe obszary i ich konfigurację.",
        //   type: "upload",
        //   actionButtons: (
        //     <Button
        //       variant="contained"
        //       sx={{
        //         width: "100%",
        //         fontSize: "13px",
        //         fontWeight: "700",
        //         margin: "auto 0 0 0",
        //         padding: "16px 12px",
        //       }}
        //     >
        //       {__("Importuj")}
        //     </Button>
        //   ),
        // }
      );
    }

    if (hasPermissionsStructureAreaExport) {
      cards.push({
        mainText: "Eksportuj do pliku",
        secondaryText: "Eksportuj do pliku wszystkie skonfigurowane obszary.",
        type: "download",
        actionButtons: (
          <Export structureId={structureId as string} companyId={companyId} />
        ),
      });
    }

    return cards;
  }, [
    companyId,
    structureId,
    hasPermissionsStructureAreaImport,
    hasPermissionsStructureAreaExport,
  ]);

  return (
    <>
      {(hasPermissionsStructureAreaImport ||
        hasPermissionsStructureAreaExport) && (
        <Button
          onClick={handleOpen}
          variant="contained"
          size="large"
          sx={{
            margin: "0 0 0 auto",
            [theme.breakpoints.down("md")]: {
              margin: "unset",
              width: "100%"
            },
          }}
        >
          {__("Importuj / Eksportuj")}
        </Button>
      )}

      <Modal open={isModalOpen} onClose={handleClose}>
        <Card
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "fit-content",
            padding: "24px",
          }}
        >
          <Box>
            <Typography
              sx={{ fontSize: "20px", fontWeight: 700, margin: "0 0 24px 0" }}
            >
              {__("Importuj / eksportuj obszary")}
            </Typography>
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={(t) => ({
                position: "absolute",
                right: "24px",
                top: "24px",
                color: t.palette.grey[500],
              })}
            >
              <CloseIcon />
            </IconButton>
          </Box>
          <Box
            sx={{
              display: "flex",
              gap: "24px",
              [theme.breakpoints.down("md")]: { flexDirection: "column" },
            }}
          >
            {dataCards.map(
              ({ mainText, secondaryText, actionButtons, type }) => (
                <DataCard
                  mainText={mainText}
                  secondaryText={secondaryText}
                  actionButtons={actionButtons}
                  type={type}
                />
              )
            )}
          </Box>
        </Card>
      </Modal>
    </>
  );
};

export default Area;
